// extracted by mini-css-extract-plugin
module.exports = {"selectSearch":"PixTaxonomyGlobalSelect_selectSearch__3mmXZ"};